"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartiesTabConfirmModal = void 0;
var React = require("react");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var PartiesTabConfirmModal = function (props) { return (React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.showWarningModal.open, close: function () {
        props.setShowWarningModal({
            open: false,
            state: props.showWarningModal.state
        });
    }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
        React.createElement(ConfirmDialog_1.Exclamation, null),
        React.createElement("div", null,
            React.createElement("div", { className: 'title please-confirm-text' },
                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
            props.showWarningModal.state === 'ENABLE' ? (React.createElement("div", { className: 'text' },
                React.createElement("p", null, (0, translation_1.getLocalization)('userfront/users-list/confirm-modal-content1-enable')),
                React.createElement("p", null, (0, translation_1.getLocalization)('userfront/users-list/confirm-modal-content2-enable')))) : (React.createElement("div", { className: 'text' },
                React.createElement("p", null, (0, translation_1.getLocalization)('userfront/users-list/confirm-modal-content1-disable')),
                React.createElement("p", null, (0, translation_1.getLocalization)('userfront/users-list/confirm-modal-content2-disable')))))), footer: React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                props.setShowWarningModal({
                    open: false,
                    state: props.showWarningModal.state
                });
                props.toggleShowParties(props.projectId, !props.showPartiesTab);
            } }),
        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () {
                props.setShowWarningModal({
                    open: false,
                    state: props.showWarningModal.state
                });
            } })) })); };
exports.PartiesTabConfirmModal = PartiesTabConfirmModal;
